import { render, staticRenderFns } from "./saleOriginalPrint.vue?vue&type=template&id=34c163f8&scoped=true&"
import script from "./saleOriginalPrint.vue?vue&type=script&lang=js&"
export * from "./saleOriginalPrint.vue?vue&type=script&lang=js&"
import style0 from "./saleOriginalPrint.vue?vue&type=style&index=0&id=34c163f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c163f8",
  null
  
)

export default component.exports